export default {
  activateGtm(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l != 'dataLayer' ? `&l=${l}` : '';
    j.async = true;
    const nonceSource = d.querySelector('script[nonce],style[nonce]');
    if (nonceSource) j.nonce = nonceSource.nonce || nonceSource.getAttribute('nonce');
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
    const parent = f?.parentNode || d.head || d.body;
    if (f && parent) {
      parent.insertBefore(j, f);
      return;
    }
    if (parent) parent.appendChild(j);
  },
};
